import { TmTransportError } from '@/core/error/transport/tmTransportError'

type TmTaxSaveErrorType = 'eu_vat' | 'au_abn' | 'ca_gst_hst'

export class TmTaxSaveError extends TmTransportError<Error> {
  public readonly taxType: TmTaxSaveErrorType

  public name = 'TmTaxSaveError'

  constructor(msg: string, data: Error, taxType: TmTaxSaveErrorType) {
    super(msg, data)
    this.taxType = taxType
  }
}
